<template>
  <div>
    <div class="unlocked-badges-skeleton">
      <div v-for="(item, idx) in unlockedBadges" :key="idx">
        <div class="unlocked-slide-card my-md-5 d-flex flex-column  shadow-sm">
          <b-skeleton-img class="unlocked-slide-image"></b-skeleton-img>
          <b-skeleton width="90%"></b-skeleton>
          <div class="unlocked-slide-info d-flex flex-column justify-content-between">
            <div class="unlocked-slide-progress">
              <b-skeleton width="45px" class="unlocked-slide-progress-text"></b-skeleton>
              <b-skeleton class="unlocked-slide-progress-bar"> </b-skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="locked-badges-skeleton">
      <div v-for="(item, idx) in lockedBadges" :key="idx">
        <div class="locked-slide-card my-md-5 d-flex flex-row  shadow-sm">
          <b-skeleton-img class="locked-image"></b-skeleton-img>
          <div class="locked-slide-info">
            <b-skeleton width="50%"></b-skeleton>
            <b-skeleton width="80%"></b-skeleton>
            <div class="locked-slide-progress">
              <b-skeleton width="45px" class="locked-slide-progress-text"></b-skeleton>
              <b-skeleton class="locked-slide-progress-bar"> </b-skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      unlockedBadges: [1, 2, 3],
      lockedBadges: [1, 2, 3, 4],
    };
  },
};
</script>

<style lang="scss" scoped>
.unlocked-badges-skeleton {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  .unlocked-slide-card {
    justify-content: space-between;
    align-items: center;
    border-radius: 9px;
    overflow: hidden;
    width: 60%;
    height: 280px;
    margin: auto;

    .unlocked-slide-image {
      width: 300px;
    }

    .unlocked-slide-info {
      width: 100%;
      padding: 10px;
      gap: 1rem;

      .unlocked-slide-progress {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: auto;

        .unlocked-slide-progress-text {
          font-weight: 600;
          margin-left: auto;
          margin-bottom: 5px;
        }

        .unlocked-slide-progress-bar {
          width: 100%;
          height: 5px;
        }
      }
    }
  }
}

.locked-badges-skeleton {
  display: contents;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  .locked-slide-card {
    flex-direction: row;
    border-radius: 9px;
    overflow: hidden;
    width: min(100%, 500px);
    margin: auto;
    margin-top: 20px;

    .locked-image {
      width: 130px;
      height: 90px;
      margin: 5px;
      border-radius: 9px;
    }

    .locked-slide-info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 10px 10px 10px 10px;
      width: 100%;

      .locked-slide-progress {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: auto;

        .locked-slide-progress-text {
          font-weight: 600;
          margin-left: auto;
          margin-bottom: 5px;
        }

        .locked-slide-progress-bar {
          width: 100%;
          height: 5px;
        }
      }
    }
  }
}
</style>

